import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["modal"]

    connect() {
        // Close modal when clicking outside
        this.modalTarget.addEventListener("click", (e) => {
            if (e.target === this.modalTarget) {
                this.close()
            }
        })

        // Close modal when pressing ESC
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                this.close()
            }
        })
    }

    open() {
        this.#clearFlashMessage()
        this.modalTarget.classList.remove("hidden")
        document.body.style.overflow = "hidden" // Prevent scrolling
    }

    close() {
        this.modalTarget.classList.add("hidden")
        document.body.style.overflow = "auto"
    }

    async submit(event) {
        event.preventDefault()
        const form = event.currentTarget

        try {
            const response = await fetch(form.action, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
                },
                body: JSON.stringify(Object.fromEntries(new FormData(form)))
            })

            const data = await response.json()

            if (!response.ok) {
                this.#showMessage(data.error, false)
            } else {
                this.#showMessage(data.message, true)
                setTimeout(() => window.location.reload(), 1000)
            }
        } catch (error) {
            this.#showMessage(error.message, false)
        }
    }

    #showMessage(message, succeeded) {
        document.getElementById(
            "flash-message"
        ).innerHTML = `<span class="text-${succeeded ? "green" : "red"}-500">${message}</span>`
    }

    #clearFlashMessage() {
        document.getElementById(
            "flash-message"
        ).innerHTML = ""
    }
}